import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M12.002 6.872A5.12 5.12 0 0 0 6.876 12a5.12 5.12 0 0 0 5.126 5.128A5.12 5.12 0 0 0 17.13 12a5.12 5.12 0 0 0-5.127-5.128m0 8.462A3.34 3.34 0 0 1 8.67 12a3.337 3.337 0 0 1 3.333-3.334A3.337 3.337 0 0 1 15.335 12a3.34 3.34 0 0 1-3.333 3.334m6.532-8.671c0 .664-.535 1.196-1.195 1.196a1.196 1.196 0 1 1 1.196-1.196m3.396 1.213c-.076-1.602-.442-3.02-1.615-4.19-1.17-1.17-2.588-1.535-4.19-1.616-1.65-.093-6.6-.093-8.25 0-1.597.076-3.016.442-4.19 1.611-1.173 1.17-1.534 2.589-1.615 4.19-.093 1.652-.093 6.601 0 8.253.076 1.602.442 3.02 1.615 4.19s2.588 1.535 4.19 1.616c1.65.093 6.6.093 8.25 0 1.602-.076 3.02-.442 4.19-1.616 1.168-1.17 1.534-2.588 1.615-4.19.093-1.652.093-6.596 0-8.248m-2.133 10.02a3.38 3.38 0 0 1-1.9 1.9c-1.317.523-4.44.402-5.895.402s-4.582.116-5.894-.401a3.38 3.38 0 0 1-1.9-1.902c-.523-1.316-.402-4.44-.402-5.895s-.116-4.583.401-5.895a3.38 3.38 0 0 1 1.901-1.902c1.316-.522 4.44-.401 5.894-.401 1.455 0 4.582-.116 5.894.401a3.38 3.38 0 0 1 1.901 1.902c.522 1.316.401 4.44.401 5.895s.121 4.583-.401 5.895"
    }, null, -1)
  ]))]))
}
export default { render: render }